import { euroFormatterIt } from 'app/src/shared/helpers'
import { Card } from 'primereact/card'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function DoNotConvertCard(props: Readonly<{ accountDoNotConvert?: number }>): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.FirstStep' })
  const tCommon = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Common' })
  return (
    <Card className='bg-[var(--card-background)] pl-16 pr-16 text-center'>
      <div className='h-48 flex-grow align-middle leading-loose'>{t('doNotConvertCard.text')}</div>
      <div>
        <div
          className='rounded-3xl border border-[var(--primary-color)] p-4 text-[var(--primary-color)]'
          dangerouslySetInnerHTML={{
            __html: t('doNotConvertCard.buttonText'),
          }}
        ></div>
        <div className='mt-2 h-12 flex-grow'>{t('doNotConvertCard.textBeforeFigure')}</div>
        <div className='text-[50px] text-[var(--primary-color)]'>
          {props.accountDoNotConvert ? euroFormatterIt.format(props.accountDoNotConvert) : tCommon.t('notAvailableText')}
        </div>
      </div>
    </Card>
  )
}
